import React from 'react';
import { useLocation } from 'react-use';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';

import Layout from '@/components/Layout';
import NewsList from '@/components/News';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'news', 'path', 'form'])),
    },
  };
};

const News = () => {
  const { t } = useTranslation(['news', 'common']);
  const state = useLocation();

  return (
    <div>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-新闻资讯-title'),
          description: t('common:seo-新闻资讯-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-新闻资讯-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-新闻资讯-title')}</title>
        <meta name="description" content={t('common:seo-新闻资讯-description')} />
        <meta name="keywords" content={t('common:seo-新闻资讯-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-新闻资讯-title')}
        />
      </Head>
      <NewsList />
    </div>
  );
};

export default News;

News.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
